/**
 * The main api service
 */
import localDb from "./localDb";

const LOGIN_USER = "LOGIN_USER";

export default {
  /**
   * 保存登陆用户信息
   */
  setUser(user) {
    return localDb.set(LOGIN_USER, user);
  },

  /**
   * 获取登陆角色信息
   */
  getUser() {
    return localDb.get(LOGIN_USER);
  },

  /**
   * 清空登陆用户信息
   */
  clearUser() {
    localDb.set(LOGIN_USER);
  },
};



// WEBPACK FOOTER //
// ./src/util/local.js